import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantService } from '../services/tenant.service';
import { PUBLIC_REQUEST } from './public-request.token';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(PUBLIC_REQUEST) || req.url.endsWith('/api/me') || req.headers.has('X-Tenant-Key')) {
    return next(req);
  }

  const tenantKey = inject(TenantService).tenantKey();

  if (!tenantKey) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { 'X-Tenant-Key': tenantKey } }));
};
